module.exports = __webpack_public_path__ + "img/1724037254129-Buket.jpg.2c11e096.webp";